'use client';

import { Suspense, type ReactNode } from 'react';
import { SignupAreaBoundary, SignupRewardsCarousel } from '@/features/signup';

/**
 * Every signup page shares this layout, so leaving the signup pages unmounts
 * it. It also carries the rewards card, which keeps its place in the rotation
 * as the member moves between steps.
 */
export default function SignupLayout({ children }: { children: ReactNode }) {
  return (
    <SignupAreaBoundary>
      {children}
      <Suspense fallback={null}>
        <SignupRewardsCarousel />
      </Suspense>
    </SignupAreaBoundary>
  );
}
